import script from "./FragmentFullGroups.vue?vue&type=script&setup=true&lang=ts"
export * from "./FragmentFullGroups.vue?vue&type=script&setup=true&lang=ts"

import "./FragmentFullGroups.vue?vue&type=style&index=0&id=11c6b9b4&scoped=true&lang=sass"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11c6b9b4"]])

export default __exports__